import { MacrosUpdateRequest } from "@/clients/models/MacrosUpdateRequest";
import { NutritionalRequirementsService } from "@/clients/services/NutritionalRequirementsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUpdateMacros = () => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.NUTRITIONAL_REQUIREMENT, "update-macros"],
    mutationFn: async (macrosUpdate: MacrosUpdateRequest) => {
      const user = guardGetUserFromLocalStorage();
      return NutritionalRequirementsService.updateMacrosApiV1NutritionalRequirementsMacrosPut(
        user.id,
        macrosUpdate,
      );
    },
    onSuccess: () => {
      // Invalidate macros query to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.NUTRITIONAL_REQUIREMENT, "macros"],
      });
      // Also invalidate the general nutritional requirement query
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.NUTRITIONAL_REQUIREMENT],
      });
      // Invalidate calorie budget as macros affect it
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.CALORIE_BUDGET],
      });
    },
  });

  return {
    updateMacros: mutate,
    updateMacrosAsync: mutateAsync,
    isUpdating: isPending,
    isError,
    error,
  };
};
